import { ReactNode, useState } from 'react';
import Container from 'components/Dialog/Container';
import { useKey } from 'react-use';

interface ButtonRenderProp {
  ({ toggle }: { toggle(): void }): ReactNode;
}

interface ContentRenderProp {
  ({ hide }: { hide(): void }): ReactNode;
}

interface Props {
  isShown?: boolean;
  button: ButtonRenderProp;
  content: ContentRenderProp;
  displayCloseButton?: boolean;
}

export default function Dialog({
  isShown: initialIsShown,
  button,
  content,
  displayCloseButton,
}: Props): JSX.Element {
  const [isShown, setIsShown] = useState(initialIsShown);

  function toggle(): void {
    setIsShown(!isShown);
  }

  function hide(): void {
    setIsShown(false);
  }

  useKey('Escape', hide);

  return (
    <>
      {button({ toggle })}
      <Container
        hide={hide}
        isShown={Boolean(isShown)}
        render={(): ReactNode => content({ hide })}
        displayCloseButton={displayCloseButton}
      />
    </>
  );
}
